var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "activityiesListView", staticClass: "activity-list-view" },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.loading } },
        [
          _vm.activities.length > 0
            ? _vm._l(Object.keys(_vm.groups()), function (date) {
                return _c("div", { key: date, staticClass: "date-group" }, [
                  _c("div", { staticClass: "date" }, [
                    _vm._v(
                      _vm._s(_vm.$moment(date, "YYYY-MM-DD").format("LL"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "activity-cards" },
                    _vm._l(_vm.groups()[date], function (activity) {
                      return _c("ActivityCard", {
                        key: activity._id,
                        attrs: { activity: activity },
                      })
                    }),
                    1
                  ),
                ])
              })
            : _c("div", { staticClass: "empty-activities" }, [
                _c(
                  "div",
                  { staticClass: "material-icons notification-shake" },
                  [_vm._v("notifications_active")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "empty-message-title" }, [
                  _vm._v(_vm._s(_vm.$t("notification.noActivityTitle"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "empty-message" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("notification.noActivityDesc")) +
                      "\n            "
                  ),
                ]),
              ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }